import Link from "next/link";

import { useIsEmbed } from "@calcom/embed-core/embed-iframe";
import { APP_NAME, POWERED_BY_URL, LOGO } from "@calcom/lib/constants";
import { useLocale } from "@calcom/lib/hooks/useLocale";

const PoweredByCal = ({
  logoOnly,
  hasValidLicense,
}: {
  logoOnly?: boolean;
  hasValidLicense?: boolean | null;
}) => {
  const { t } = useLocale();
  const isEmbed = useIsEmbed();

  // If a custom logo is provided, render the image. Otherwise, render the custom brand name as text.
  const hasCustomLogo = LOGO && LOGO !== "/calcom-logo-white-word.svg";

  return (
    <div className={`p-2 text-center text-xs sm:text-right${isEmbed ? " max-w-3xl" : ""}`}>
      <Link href={POWERED_BY_URL} target="_blank" className="text-subtle">
        {!logoOnly && <>{t("powered_by")} </>}
        {hasCustomLogo ? (
          <img
            className="-mt-px inline h-[16px] w-auto dark:invert opacity-60 hover:opacity-100 transition-opacity"
            src={LOGO}
            alt={`${APP_NAME} Logo`}
          />
        ) : (
          <span className="text-emphasis font-semibold opacity-50 hover:opacity-100">{APP_NAME}</span>
        )}
      </Link>
    </div>
  );
};

export default PoweredByCal;
